import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import gettext from '@eb/gettext';

import { ValidationFormField } from '@eb/eds-validation-form-field';
import { InputField } from '@eb/eds-input-field';

import { shouldDisplayError } from '@eb/redux-form-tools';

export default class ConfirmEmailField extends PureComponent {
    static propTypes = {
        autoFocus: PropTypes.bool,
    };
    _handlePaste(e) {
        // Avoid paste in input
        e.preventDefault();
    }

    render() {
        const { autoFocus } = this.props;
        return (
            <div className="eds-l-mar-bot-4">
                <ValidationFormField
                    name="confirmEmail"
                    label={gettext('Confirm email')}
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <InputField
                        id="confirmEmail"
                        name="confirmEmail"
                        autoFocus={autoFocus}
                        onPaste={this._handlePaste}
                        label={gettext('Confirm email')}
                        type="email"
                        role="textbox"
                        data-automation="authentication-email-confirm-field"
                    />
                </ValidationFormField>
            </div>
        );
    }
}
